"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryOrderMode = exports.TraderAccountRiskState = exports.FuturePositionFlag = void 0;
var FuturePositionFlag;
(function (FuturePositionFlag) {
    /**交易平仓 正常平仓*/
    FuturePositionFlag["CLOSED"] = "CLOSED";
    /**被接管 系统强平*/
    FuturePositionFlag["TAKEOVER"] = "TAKEOVER";
})(FuturePositionFlag = exports.FuturePositionFlag || (exports.FuturePositionFlag = {}));
var TraderAccountRiskState;
(function (TraderAccountRiskState) {
    /**交易状态 */
    TraderAccountRiskState["TRADING"] = "TRADING";
    /**受控状态,权益小于占用 */
    TraderAccountRiskState["HOLDING"] = "HOLDING";
    // ——————下方所有状态表示权益小于维持————————
    /**合并状态 */
    TraderAccountRiskState["MERGING"] = "MERGING";
    /**强平状态 */
    TraderAccountRiskState["LIQUIDATING"] = "LIQUIDATING";
    /**接管状态 */
    TraderAccountRiskState["TAKEOVER"] = "TAKEOVER";
})(TraderAccountRiskState = exports.TraderAccountRiskState || (exports.TraderAccountRiskState = {}));
/**查询历史委托时的order_mode字段对应的值 */
var QueryOrderMode;
(function (QueryOrderMode) {
    /**用户发起的订单或空字符串）：普通订单 */
    QueryOrderMode["NORMAL"] = "NORMAL";
    // 系统生成的订单
    /**强平订单（盘内）*/
    QueryOrderMode["LIQUIDATION"] = "LIQUIDATION";
    /**自身多空对抵（盘外） */
    QueryOrderMode["INNERMERGE"] = "INNERMERGE";
    /**强平队列多空对抵（盘外） */
    QueryOrderMode["CROSSMERGE"] = "CROSSMERGE";
    /**系统接管（盘外） */
    QueryOrderMode["TAKEOVER"] = "TAKEOVER";
})(QueryOrderMode = exports.QueryOrderMode || (exports.QueryOrderMode = {}));
